const root = () => window.Shopify?.routes?.root || '/';
const money = (cents) => new Intl.NumberFormat('en-IN', {
  style: 'currency', currency: window.Shopify?.currency?.active || 'INR', maximumFractionDigits: cents % 100 ? 2 : 0,
}).format(cents / 100);

class ProductPage extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
    this.form = this.querySelector('#ProductForm');
    this.button = this.querySelector('[data-add]');
    this.buyNow = this.querySelector('[data-buy-now]');
    this.form.addEventListener('change', () => this.onOptionChange());
    this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });
    this.buyNow?.addEventListener('click', () => this.add(true));

    const bar = this.querySelector('[data-bar]');
    if (bar) {
      new IntersectionObserver(([e]) => {
        const on = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', !on);
      }).observe(this.button);
      bar.querySelector('button')?.addEventListener('click', () => this.add());
    }
    this.setupZoom();
  }

  selectedVariant() {
    const sets = [...this.form.querySelectorAll('fieldset')];
    if (!sets.length) {
      const id = +this.form.querySelector('[data-variant-id]').value;
      return this.variants.find((v) => v.id === id) || this.variants[0];
    }
    const picked = sets.map((fs) => fs.querySelector('input:checked')?.value);
    return this.variants.find((v) => v.options.every((o, i) => o === picked[i]));
  }

  onOptionChange() {
    const v = this.selectedVariant();
    const ok = v && v.available;
    this.button.disabled = !ok;
    if (this.buyNow) { this.buyNow.disabled = !ok; this.buyNow.textContent = this.strings.buyNow; }
    this.button.textContent = !v ? this.strings.unavailable : v.available ? this.strings.add : this.strings.soldOut;
    if (!v) return;
    this.form.querySelector('[data-variant-id]').value = v.id;
    this.querySelectorAll('[data-price]').forEach((el) => { el.textContent = money(v.price); });
    const onSale = v.compare_at_price > v.price;
    this.querySelectorAll('[data-compare]').forEach((el) => { el.hidden = !onSale; el.textContent = onSale ? money(v.compare_at_price) : ''; });
    this.querySelectorAll('[data-save]').forEach((el) => {
      el.hidden = !onSale;
      if (onSale) el.textContent = this.strings.save.replace('PCT', Math.round((1 - v.price / v.compare_at_price) * 100));
    });
    const url = new URL(location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState({}, '', url);
  }

  async add(checkout = false) {
    const btn = checkout ? this.buyNow : this.button;
    btn.disabled = true;
    btn.classList.add('is-loading');
    try {
      const res = await fetch(`${root()}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form) });
      if (!res.ok) throw new Error((await res.json()).description);
      if (checkout) {
        const go = document.getElementById('BuyNowCheckout');
        if (go) go.click(); else location.href = `${root()}checkout`;
        return;
      }
      const cart = await (await fetch(`${root()}cart.js`)).json();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: cart.item_count } }));
      this.button.textContent = this.strings.added;
      this.button.classList.add('is-added');
      setTimeout(() => { this.button.classList.remove('is-added'); this.onOptionChange(); }, 1600);
    } catch (err) {
      btn.textContent = err.message || this.strings.unavailable;
      setTimeout(() => this.onOptionChange(), 2200);
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }

  setupZoom() {
    const dialog = this.querySelector('[data-zoom-dialog]');
    const big = dialog?.querySelector('img');
    const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
    this.querySelectorAll('[data-zoom]').forEach((slide) => {
      const img = slide.querySelector('img');
      if (fine && img) {
        slide.addEventListener('pointermove', (e) => {
          const r = slide.getBoundingClientRect();
          img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
          slide.classList.add('is-zooming');
        });
        slide.addEventListener('pointerleave', () => slide.classList.remove('is-zooming'));
      }
      slide.querySelector('[data-zoom-open]')?.addEventListener('click', () => {
        if (!dialog) return;
        big.src = slide.dataset.zoom;
        dialog.showModal();
        requestAnimationFrame(() => {
          const pane = dialog.querySelector('.zoom__pane');
          pane.scrollLeft = (pane.scrollWidth - pane.clientWidth) / 2;
          pane.scrollTop = (pane.scrollHeight - pane.clientHeight) / 2;
        });
      });
    });
    dialog?.addEventListener('click', (e) => { if (e.target === dialog || e.target.closest('[data-zoom-close]')) dialog.close(); });
  }
}
customElements.define('product-page', ProductPage);
